<template>
<section class="horizontal-separator px-4 py-8" aria-hidden="true">
    <div class="max-w-4xl mx-auto">
        <div class="bg-gray-600 w-full" style="height: 2px;"></div>
    </div>
</section>
</template>